import { ApiProperty } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsOptional } from 'class-validator';

import { SpConnectBuilderAddressDto } from './sp-connect-builder-address.dto';
import { SpConnectBuilderInterface } from '../interfaces/sp-connect-builder.interface';

export class SpConnectBuilderDto implements SpConnectBuilderInterface {
  @ApiProperty()
  @IsOptional()
  @Type(() => SpConnectBuilderAddressDto)
  address?: SpConnectBuilderAddressDto;
}
